import React, { useState, useEffect } from "react";
import axios from "../config/axios";
import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";

import SchoolForm from "../components/common/SchoolForm";
import { useGeneral } from "../components/contexts/GeneralContext";
import FullScreenLoading from "../components/common/loading/FullScreenLoading";
const usePageContent = () => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState(null);
  const [error, setError] = useState("");
  const { discountCoupons,setExtraContent } = useGeneral();

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        const { data } = await axios.get("page-content/school-form-screen");
        if (active) setContent(data || null);
         setExtraContent((prev) => ({
          ...prev,
          socialChannels: data?.socialChannels,
           whatsAppNumber: data?.whatsAppNumber,
        }));
      } catch (err) {
        console.error(err);
        if (active)
          setError("Failed to load contact content. Please try again later.");
      } finally {
        if (active) setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  return { content, loading, error, discountCoupons };
};

const useScrollToTop = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  }, []);
};

const SchoolsPage = () => {
  const { content, loading, error, discountCoupons } = usePageContent();
  useScrollToTop();

  return (
    <>
      {loading && <FullScreenLoading />}
      <PageWrapper loading={true} className="bg-bg min-h-screen">
        <Header code={discountCoupons} />
        <BodyWrapper loading={loading} className="">
          <SchoolForm content={content} />
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default SchoolsPage;
